import { unTriggeredRuleResult } from '../utils';

/**
 * Used to validate the length of the input string value for multiline.
 * The validation includes all the characters in the string.
 * @param params
 * @param value
 */
export const maxCharsMultiLineRule = (params, value) => {
  if (typeof value !== 'string') {
    return unTriggeredRuleResult;
  }
  let triggered = false;
  let remainingChars = 0;
  if (params.maxLength !== undefined) {
    triggered = true;
    remainingChars = params.maxLength - (value ? value.length : 0);
  }
  const messageType = remainingChars < 0 ? 'error' : 'msg';
  return {
    triggered,
    validationState: {
      isValid: !triggered,
      message: triggered ? params.customErrorMessages?.exceedsMaxLength || `${remainingChars} characters remaining` : undefined,
      type: triggered ? messageType : undefined,
      messageKey: 'maxCharsMultiline'
    }
  };
};